import { ALIGN_TYPES, VALUE_TYPES as THVT } from "../../../configs/TableHeaderConstants";
import VALUE_TYPES from "../../../configs/ValueTypeConstants";
import * as Yup from 'yup';

export const DEBIT_NOTE_TABLE_HEADS = [
    { id: 'dn_number', label: 'DN Number', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.NUMBER },
    { id: 'debit_note_date', label: 'DN Date', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.DATE },
    { id: 'debit_ledger_name', label: 'Account Name (Debit)', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.NUMBER },
    { id: 'debit_amount', label: 'Debit Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.EDIT },
]

export const DEBIT_NOTE_STATE = {
    debit_note_date: null,
    debit_ledger_id: null,
    debit_amount: 0,
    address: null,
    trn: null
};

export const DEBIT_NOTE_SCHEMA = Yup.object().shape({
    debit_note_date: Yup.date().required(),
    debit_ledger_id: Yup.number().required(),
    debit_amount: Yup.number().nullable(),
    address: Yup.string().nullable(),
    trn: Yup.string().required()
});

export const DEBIT_NOTE_FORM_FIELDS = [
    { name: "dn_number", title: "DN Number", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "debit_note_date", title: "DN Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "debit_ledger_id", title: "Account Name (Debit)", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "debit_amount", title: "Debit Amount (AED)", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "trn", title: "TRN", required: true, type: VALUE_TYPES.TEXT },
    { name: "address", title: "Address", required: false, type: VALUE_TYPES.TEXT },
];

export const DEBIT_NOTE_LINE_TABLE_HEADS = [
    { id: 'credit_ledger_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.NUMBER, width: 150 },
    { id: 'credit_ledger_name', label: 'Account Name (Credit)', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 250 },
    { id: 'particulars', label: 'Particulars', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 400 },
    { id: 'amount', label: 'Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER, width: 150 },
    { id: 'icon_btns', label: 'Edit / Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.ICONBTNS, buttons: ["edit", "delete"] },
]

export const DEBIT_NOTE_LINE_STATE = {
    credit_ledger_id: null,
    particulars: null,
    amount: 0,
};

export const DEBIT_NOTE_LINE_SCHEMA = Yup.object().shape({
    credit_ledger_id: Yup.number().required(),
    particulars: Yup.string().required(),
    amount: Yup.number().required()
});

export const DEBIT_NOTE_LINE_FORM_FIELDS = [
    { name: "credit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    // { name: "credit_ledger_id", title: "Account Name (Credit)", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: false },
    { name: "particulars", title: "Particulars", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "amount", title: "Amount (AED)", required: true, type: VALUE_TYPES.DECIAML, disabled: false },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];


const filterState = {
    accounts: null,
    from_date: null,
    to_date: null
};
const filterSchema = Yup.object().shape({
    accounts: Yup.array().nullable(),
    from_date: Yup.date().nullable(),
    to_date: Yup.date().nullable(),
});

const filterFormFields = [
    { name: "accounts", title: "Accounts", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "from_date", title: "From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "to_date", title: "To Date", required: false, type: VALUE_TYPES.DATEPICKER },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}

